<template>
	<div class="employer-container">
			<div class="row page-heading">
				<div class="col-7 input module_heading">
					<div class="module_icon ico-employer"></div>
					<label class="head_txt module_type_name">{{employer.title}}</label>
				</div>
				<div class="col-5 float-right px-0">
					<div class="btn-container">
					</div>
				</div>
			</div>

			<div class="page-content-section row">
	        	<div class="left-side">
	          		<employer-menu :uuid="uuid" active="home"></employer-menu>
	        	</div>
	        	<div class="report right-panel">
    					<div class="right-nav">Reports</div>

    					<div class="content-row">
                <iframe class="report-iframe" :src="report" height="400" width="850"></iframe>
    					</div>
	        	</div>
			</div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import EmployerMenu from './EmployerMenu'
import JobResult from './JobResult'

export default {
  name: 'employerHome',
  props: ['uuid'],
  components: {
    EmployerMenu,
    JobResult
  },
  data: () => {
    return {
    }
  },

  mounted () {
    this.loadEmployer()
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadEmployerDetail',
      'loadAllJobs',
      'loadEmployerReport'
    ]),

    loadEmployer () {
      this.loadEmployerDetail(this.uuid)
      this.loadAllJobs(this.uuid)
      this.loadEmployerReport()
    }

  },

  computed: {
    ...mapState({
      'employer': state => state.employer.employer,
      'categories': state => state.employer.categories,
      'report': state => state.employer.report
    })
  },

  watch: {
  }
}
</script>
<style>
.margin-top-10 {
  margin-top: 10px;
}
.margin-top-20 {
  margin-top: 20px;
}
.margin-top-30 {
  margin-top: 30px;
}
.no-border {
  border: none;
}
.margin-left-20 {
  margin-left: 20px;
}
.report-iframe{
  border: none;
}
.report {
  background: #F5F5F5;
}
</style>



// WEBPACK FOOTER //
// src/app/employer/components/EmployerReport.vue